import api from '../../../dependencies/utils/Api';

import {
    DOWNLOAD_INCOMPLETE_80IAC_REPORT,
} from '../../../constants/ApplicationUrl';

export const startup80iacReportService = {

    downloadReport(params) {
        return api.DOWNLOADDATA(`${DOWNLOAD_INCOMPLETE_80IAC_REPORT}`,params).
            then((data) => {
                return data;
            }).catch(e => {
                return Promise.reject(e);
            })
    }
}